msgid ""
msgstr ""
"POT-Creation-Date: 2021-01-20 11:28+0100\n"
"Mime-Version: 1.0\n"
"Content-Type: text/plain; charset=utf-8\n"
"Content-Transfer-Encoding: 8bit\n"
"X-Generator: @lingui/cli\n"
"Language: en\n"
"Project-Id-Version: \n"
"Report-Msgid-Bugs-To: \n"
"PO-Revision-Date: \n"
"Last-Translator: \n"
"Language-Team: \n"
"Plural-Forms: \n"

msgid "“{loginLabel}” was deleted."
msgstr "“{loginLabel}” was deleted."

#. placeholder {0}: getMoveTargetLabel(movedLoginInfo)
msgid "“{loginLabel}” was moved to “{0}”."
msgstr "“{loginLabel}” was moved to “{0}”."

msgid "“{loginLabel}” was moved to the <0>recycle bin</0>."
msgstr "“{loginLabel}” was moved to the <0>recycle bin</0>."

#. placeholder {0}: movedLoginInfo.recipientEmail
msgid "“{loginLabel}” was transferred to the personal logins of “{0}”."
msgstr "“{loginLabel}” was transferred to the personal logins of “{0}”."

msgid "(changed)"
msgstr "(changed)"

#. placeholder {0}: validUntilWarning.days
msgid "{0, plural, =0 {Expired today} one {Expired yesterday} other {Expired # days ago}}"
msgstr "{0, plural, =0 {Expired today} one {Expired yesterday} other {Expired # days ago}}"

#. placeholder {0}: validUntilWarning.days
msgid "{0, plural, =0 {Expires today} one {Expires tomorrow} other {Expires in # days}}"
msgstr "{0, plural, =0 {Expires today} one {Expires tomorrow} other {Expires in # days}}"

#. placeholder {0}: validFromWarning.days
msgid "{0, plural, =0 {Valid from later today} one {Valid from tomorrow} other {Valid in # days}}"
msgstr "{0, plural, =0 {Valid from later today} one {Valid from tomorrow} other {Valid in # days}}"

msgid "{fieldName} (old)"
msgstr "{fieldName} (old)"

msgid "#@$"
msgstr "#@$"

#. placeholder {0}: format(new Date(login.importInfo.importTime), 'PPPp', { locale: getDateFnsLocale(), })
msgid "<0>Imported</0> on {0}"
msgstr "<0>Imported</0> on {0}"

msgid "0{nonBreakingHyphen}9"
msgstr "0{nonBreakingHyphen}9"

msgid "a{nonBreakingHyphen}z"
msgstr "a{nonBreakingHyphen}z"

msgid "A{nonBreakingHyphen}Z"
msgstr "A{nonBreakingHyphen}Z"

msgid "Active"
msgstr "Active"

msgid "Add"
msgstr "Add"

msgid "Add android app"
msgstr "Add android app"

msgid "Add display name"
msgstr "Add display name"

msgid "Add more"
msgstr "Add more"

msgid "Add new field"
msgstr "Add new field"

msgid "Add title"
msgstr "Add title"

msgid "Add TOTP secret"
msgstr "Add TOTP secret"

msgid "Add website"
msgstr "Add website"

msgid "Add windows app"
msgstr "Add windows app"

msgid "All fields are end-to-end encrypted."
msgstr "All fields are end-to-end encrypted."

msgid "Alt"
msgstr "Alt"

msgid "An error happened because the page was modified by an extension or translation tool. Please disable translation or extensions and try again."
msgstr "An error happened because the page was modified by an extension or translation tool. Please disable translation or extensions and try again."

msgid "Android app"
msgstr "Android app"

msgid "Android apps"
msgstr "Android apps"

msgid "App"
msgstr "App"

msgid "Apply"
msgstr "Apply"

msgid "Autofill"
msgstr "Autofill"

msgid "Autofill enabled"
msgstr "Autofill enabled"

msgid "Browse"
msgstr "Browse"

msgid "by {creationProfileEmail}"
msgstr "by {creationProfileEmail}"

msgid "by {editProfileEmail}"
msgstr "by {editProfileEmail}"

msgid "Cancel"
msgstr "Cancel"

msgid "Card holder"
msgstr "Card holder"

msgid "Card number"
msgstr "Card number"

msgid "Certificate accepted"
msgstr "Certificate accepted"

msgid "Change"
msgstr "Change"

msgid "Change settings"
msgstr "Change settings"

msgid "Checking file…"
msgstr "Checking file…"

msgid "Checking system clock…"
msgstr "Checking system clock…"

msgid "Checking…"
msgstr "Checking…"

msgid "Clear"
msgstr "Clear"

msgid "Close"
msgstr "Close"

msgid "Compliant"
msgstr "Compliant"

msgid "Confirm access"
msgstr "Confirm access"

msgid "Confirm with one of your login devices"
msgstr "Confirm with one of your login devices"

msgid "Confirm with your phone"
msgstr "Confirm with your phone"

msgid "Confirm with your security key"
msgstr "Confirm with your security key"

msgid "Copied"
msgstr "Copied"

msgid "Copy"
msgstr "Copy"

#. placeholder {0}: format(new Date(login.creationTime), 'PPPp', { locale: getDateFnsLocale(), })
#. placeholder {0}: format(new Date(login.creationTime), 'PPPp', { locale: getDateFnsLocale(), })
msgid "Created on {0}"
msgstr "Created on {0}"

msgid "Creation Date"
msgstr "Creation Date"

msgid "Credit card"
msgstr "Credit card"

msgid "Ctrl"
msgstr "Ctrl"

msgid "Custom settings"
msgstr "Custom settings"

msgid "Default settings"
msgstr "Default settings"

msgid "Del"
msgstr "Del"

msgid "Delegated Admins"
msgstr "Delegated Admins"

msgid "Delete"
msgstr "Delete"

msgid "Disable multiline"
msgstr "Disable multiline"

msgid "Display name"
msgstr "Display name"

msgid "Does not match recommendation"
msgstr "Does not match recommendation"

msgid "Done"
msgstr "Done"

msgid "Download"
msgstr "Download"

msgid "Drag and drop or"
msgstr "Drag and drop or"

msgid "Drop new certificate file here"
msgstr "Drop new certificate file here"

msgid "Duplicate login"
msgstr "Duplicate login"

msgid "Duplicating…"
msgstr "Duplicating…"

msgid "E-mail or username"
msgstr "E-mail or username"

msgid "ELSTER account number"
msgstr "ELSTER account number"

msgid "ELSTER Certificate"
msgstr "ELSTER Certificate"

msgid "Enable multiline"
msgstr "Enable multiline"

msgid "End"
msgstr "End"

msgid "Enter"
msgstr "Enter"

msgid "Error checking password"
msgstr "Error checking password"

msgid "Error checking TOTP availability"
msgstr "Error checking TOTP availability"

msgid "Esc"
msgstr "Esc"

msgid "Expiration date"
msgstr "Expiration date"

msgid "Expiration date (mm / yy)"
msgstr "Expiration date (mm / yy)"

msgid "Failed"
msgstr "Failed"

msgid "Field name"
msgstr "Field name"

msgid "Field settings"
msgstr "Field settings"

#. placeholder {0}: formatBytes(maxSize)
msgid "File is too large, maximum size allowed is {0}"
msgstr "File is too large, maximum size allowed is {0}"

#. placeholder {0}: formatBytes(minSize)
msgid "File is too small, minimum size required is {0}"
msgstr "File is too small, minimum size required is {0}"

#. placeholder {0}: unpackedAccept[0]
msgid "File type must be {0}"
msgstr "File type must be {0}"

msgid "File type must be one of {commaSeparatedAccept}"
msgstr "File type must be one of {commaSeparatedAccept}"

msgid "Generate password"
msgstr "Generate password"

msgid "Generate PIN"
msgstr "Generate PIN"

msgid "Generated by heylogin"
msgstr "Generated by heylogin"

msgid "Generated by: "
msgstr "Generated by: "

msgid "Go to duplicated login"
msgstr "Go to duplicated login"

msgid "Go to login"
msgstr "Go to login"

msgid "Got it"
msgstr "Got it"

msgid "heylogin was updated"
msgstr "heylogin was updated"

msgid "Hide"
msgstr "Hide"

msgid "Hide content"
msgstr "Hide content"

msgid "Home"
msgstr "Home"

#. help center link: additional login fields
msgid "https://help.heylogin.com/en/0113ca3fb5284ef08f4abbdb2571b0a3"
msgstr "https://help.heylogin.com/en/0113ca3fb5284ef08f4abbdb2571b0a3"

#. help center link: login status
msgid "https://help.heylogin.com/en/1938872c7eda802da7b7da7cb484138c"
msgstr "https://help.heylogin.com/en/1938872c7eda802da7b7da7cb484138c"

#. help center link: passkey
msgid "https://help.heylogin.com/en/2bc8872c7eda8049b518db4bb0d10b2c"
msgstr "https://help.heylogin.com/en/2bc8872c7eda8049b518db4bb0d10b2c"

#. help center link: elster certificate
msgid "https://help.heylogin.com/en/37a8872c7eda80309906df0837fe7220"
msgstr "https://help.heylogin.com/en/37a8872c7eda80309906df0837fe7220"

#. help center link: login troubleshooting
msgid "https://help.heylogin.com/en/4200f43b493c4bb18c8e16bffcd40071"
msgstr "https://help.heylogin.com/en/4200f43b493c4bb18c8e16bffcd40071"

msgid "https://help.heylogin.com/en/96e629e684bf4d3a89d0d8c47aa78395"
msgstr "https://help.heylogin.com/en/96e629e684bf4d3a89d0d8c47aa78395"

#. help center link: security keys / faq / firefox on windows error
msgid "https://help.heylogin.com/en/e7d73dc2d84c4306ad83129ae969b4d7#29c8872c7eda80ceb294e0ff292f7b51"
msgstr "https://help.heylogin.com/en/e7d73dc2d84c4306ad83129ae969b4d7#29c8872c7eda80ceb294e0ff292f7b51"

msgid "Import"
msgstr "Import"

#. placeholder {0}: format(new Date(login.importInfo.importTime), 'PPPp', { locale: getDateFnsLocale(), })
msgid "Imported on {0}"
msgstr "Imported on {0}"

msgid "Incorrect password for this certificate"
msgstr "Incorrect password for this certificate"

msgid "Input by user"
msgstr "Input by user"

msgid "Ins"
msgstr "Ins"

msgid "Invalid"
msgstr "Invalid"

msgid "Invalid card number"
msgstr "Invalid card number"

msgid "Invalid expiration date"
msgstr "Invalid expiration date"

msgid "Invalid security code"
msgstr "Invalid security code"

msgid "Label already added"
msgstr "Label already added"

msgid "Label name"
msgstr "Label name"

msgid "Labels"
msgstr "Labels"

msgid "Labels:"
msgstr "Labels:"

#. placeholder {0}: format(new Date(login.editTime), 'PPPp', { locale: getDateFnsLocale(), })
msgid "Last edited on {0}"
msgstr "Last edited on {0}"

msgid "Leak check:"
msgstr "Leak check:"

msgid "Leaked"
msgstr "Leaked"

msgid "Learn more"
msgstr "Learn more"

msgid "Length"
msgstr "Length"

msgid "Logging in"
msgstr "Logging in"

msgid "Login"
msgstr "Login"

msgid "Login cancelled"
msgstr "Login cancelled"

msgid "Login Inbox"
msgstr "Login Inbox"

msgid "Login status"
msgstr "Login status"

msgid "Manual input"
msgstr "Manual input"

msgid "Matches recommendation"
msgstr "Matches recommendation"

#. placeholder {0}: rules.length
msgid "min. {0} characters"
msgstr "min. {0} characters"

msgid "More"
msgstr "More"

msgid "More options"
msgstr "More options"

msgid "Move to recycle bin"
msgstr "Move to recycle bin"

msgid "My Logins"
msgstr "My Logins"

msgid "Name may not be empty!"
msgstr "Name may not be empty!"

msgid "Network name (SSID)"
msgstr "Network name (SSID)"

msgid "New password"
msgstr "New password"

msgid "No app found"
msgstr "No app found"

msgid "No certificate found in the file"
msgstr "No certificate found in the file"

msgid "No notification received?"
msgstr "No notification received?"

msgid "No username set"
msgstr "No username set"

msgid "Not active, can be set up"
msgstr "Not active, can be set up"

msgid "Not active. <0>Instructions</0>"
msgstr "Not active. <0>Instructions</0>"

msgid "Not compliant"
msgstr "Not compliant"

msgid "Note"
msgstr "Note"

msgid "Old password"
msgstr "Old password"

msgid "Open website"
msgstr "Open website"

msgid "Page modified unexpectedly"
msgstr "Page modified unexpectedly"

msgid "Passkey"
msgstr "Passkey"

msgid "Password"
msgstr "Password"

msgid "Password checked"
msgstr "Password checked"

msgid "Password is empty"
msgstr "Password is empty"

msgid "Password origin:"
msgstr "Password origin:"

msgid "Password policy"
msgstr "Password policy"

msgid "Password policy:"
msgstr "Password policy:"

msgid "Password policy: <0><1/> Violated</0>"
msgstr "Password policy: <0><1/> Violated</0>"

msgid "Password quality:"
msgstr "Password quality:"

msgid "Personal Logins"
msgstr "Personal Logins"

msgid "PgDn"
msgstr "PgDn"

msgid "PgUp"
msgstr "PgUp"

msgid "PIN"
msgstr "PIN"

msgid "PIN, leak check not applicable"
msgstr "PIN, leak check not applicable"

msgid "Please add an ELSTER certificate file (.pfx)"
msgstr "Please add an ELSTER certificate file (.pfx)"

msgid "Please enter a label"
msgstr "Please enter a label"

msgid "Please reload to use the latest version."
msgstr "Please reload to use the latest version."

msgid "Private account"
msgstr "Private account"

msgid "Recheck"
msgstr "Recheck"

msgid "Regenerate"
msgstr "Regenerate"

msgid "Reload"
msgstr "Reload"

msgid "Remove label"
msgstr "Remove label"

msgid "Remove shared login"
msgstr "Remove shared login"

msgid "Replace"
msgstr "Replace"

msgid "Reset"
msgstr "Reset"

msgid "Reset settings"
msgstr "Reset settings"

msgid "Restore"
msgstr "Restore"

msgid "Restoring…"
msgstr "Restoring…"

msgid "Save"
msgstr "Save"

msgid "Save {changeCount, plural, one {# change} other {# changes}}"
msgstr "Save {changeCount, plural, one {# change} other {# changes}}"

msgid "Save new entry"
msgstr "Save new entry"

msgid "Saved"
msgstr "Saved"

msgid "Saved successfully"
msgstr "Saved successfully"

msgid "Saving"
msgstr "Saving"

msgid "Secure note"
msgstr "Secure note"

msgid "Secure password"
msgstr "Secure password"

msgid "Security code"
msgstr "Security code"

#. placeholder {0}: card.code.name
#. placeholder {1}: card.code.size
msgid "Security code ({0}, {1, plural, one {# digit} other {# digits}})"
msgstr "Security code ({0}, {1, plural, one {# digit} other {# digits}})"

msgid "Security key access not allowed"
msgstr "Security key access not allowed"

msgid "Selector"
msgstr "Selector"

msgid "Sent by"
msgstr "Sent by"

msgid "Serial number"
msgstr "Serial number"

msgid "Settings"
msgstr "Settings"

msgid "Share"
msgstr "Share"

msgid "Shared link"
msgstr "Shared link"

#. placeholder {0}: passwordOrigin.senderEmail
msgid "Shared link from {0}"
msgstr "Shared link from {0}"

msgid "Shift"
msgstr "Shift"

msgid "Show"
msgstr "Show"

#. placeholder {0}: field.name
msgid "Show {0}"
msgstr "Show {0}"

msgid "Show password"
msgstr "Show password"

msgid "Show PIN"
msgstr "Show PIN"

msgid "Show security code"
msgstr "Show security code"

msgid "Show TOTP secret"
msgstr "Show TOTP secret"

msgid "Show Wi-Fi QR code"
msgstr "Show Wi-Fi QR code"

msgid "Space"
msgstr "Space"

msgid "System clock is correct now."
msgstr "System clock is correct now."

msgid "the owner"
msgstr "the owner"

msgid "There are unsaved changes. <0>Save now</0>"
msgstr "There are unsaved changes. <0>Save now</0>"

msgid "This credit card is shared from a team by {linkedByEmail}."
msgstr "This credit card is shared from a team by {linkedByEmail}."

msgid "This credit card is shared from a team."
msgstr "This credit card is shared from a team."

msgid "This credit card is shared from team {link}."
msgstr "This credit card is shared from team {link}."

msgid "This credit card is shared with you by {originEmail}."
msgstr "This credit card is shared with you by {originEmail}."

msgid "This credit card is shared with you by another user."
msgstr "This credit card is shared with you by another user."

msgid "This ELSTER certificate is shared from a team by {linkedByEmail}."
msgstr "This ELSTER certificate is shared from a team by {linkedByEmail}."

msgid "This ELSTER certificate is shared from a team."
msgstr "This ELSTER certificate is shared from a team."

msgid "This ELSTER certificate is shared from team {link}."
msgstr "This ELSTER certificate is shared from team {link}."

msgid "This ELSTER certificate is shared with you by {originEmail}."
msgstr "This ELSTER certificate is shared with you by {originEmail}."

msgid "This ELSTER certificate is shared with you by another user."
msgstr "This ELSTER certificate is shared with you by another user."

msgid "This file is not a valid ELSTER certificate"
msgstr "This file is not a valid ELSTER certificate"

msgid "This login is shared from a team by {linkedByEmail}."
msgstr "This login is shared from a team by {linkedByEmail}."

msgid "This login is shared from a team."
msgstr "This login is shared from a team."

msgid "This login is shared from team {link}."
msgstr "This login is shared from team {link}."

msgid "This login is shared with you by {originEmail}."
msgstr "This login is shared with you by {originEmail}."

msgid "This login is shared with you by another user."
msgstr "This login is shared with you by another user."

#. placeholder {0}: format(new Date(login.editTime), 'PPP', { locale: getDateFnsLocale(), })
msgid "This login was submitted to your login inbox on {0}."
msgstr "This login was submitted to your login inbox on {0}."

#. placeholder {0}: relatedDomains.length
msgid "This login will also be shown on {0} additional websites."
msgstr "This login will also be shown on {0} additional websites."

#. placeholder {0}: relatedDomains.slice(0, relatedDomains.length - 1).join(', ')
#. placeholder {1}: relatedDomains[relatedDomains.length - 1]
msgid "This login will also be shown on {0} and {1}."
msgstr "This login will also be shown on {0} and {1}."

#. placeholder {0}: relatedDomains[0]
msgid "This login will also be shown on {0}."
msgstr "This login will also be shown on {0}."

msgid "This note is shared from a team by {linkedByEmail}."
msgstr "This note is shared from a team by {linkedByEmail}."

msgid "This note is shared from a team."
msgstr "This note is shared from a team."

msgid "This note is shared from team {link}."
msgstr "This note is shared from team {link}."

msgid "This note is shared with you by {originEmail}."
msgstr "This note is shared with you by {originEmail}."

msgid "This note is shared with you by another user."
msgstr "This note is shared with you by another user."

msgid "This passkey is shared from a team by {linkedByEmail}."
msgstr "This passkey is shared from a team by {linkedByEmail}."

msgid "This passkey is shared from a team."
msgstr "This passkey is shared from a team."

msgid "This passkey is shared from team {link}."
msgstr "This passkey is shared from team {link}."

msgid "This passkey is shared with you by {originEmail}."
msgstr "This passkey is shared with you by {originEmail}."

msgid "This passkey is shared with you by another user."
msgstr "This passkey is shared with you by another user."

msgid "This password was found in a list of leaked passwords. Please do not use it!"
msgstr "This password was found in a list of leaked passwords. Please do not use it!"

msgid "This TOTP code uses parameters that differ from the default."
msgstr "This TOTP code uses parameters that differ from the default."

msgid "This Wi-Fi network is shared from a team by {linkedByEmail}."
msgstr "This Wi-Fi network is shared from a team by {linkedByEmail}."

msgid "This Wi-Fi network is shared from a team."
msgstr "This Wi-Fi network is shared from a team."

msgid "This Wi-Fi network is shared from team {link}."
msgstr "This Wi-Fi network is shared from team {link}."

msgid "This Wi-Fi network is shared with you by {originEmail}."
msgstr "This Wi-Fi network is shared with you by {originEmail}."

msgid "This Wi-Fi network is shared with you by another user."
msgstr "This Wi-Fi network is shared with you by another user."

msgid "Tip: A display name helps differentiate logins."
msgstr "Tip: A display name helps differentiate logins."

msgid "Title"
msgstr "Title"

msgid "Too many files"
msgstr "Too many files"

msgid "TOTP"
msgstr "TOTP"

msgid "TOTP (2FA) availability sourced from <0>2FA Directory</0>."
msgstr "TOTP (2FA) availability sourced from <0>2FA Directory</0>."

msgid "TOTP (2FA):"
msgstr "TOTP (2FA):"

msgid "TOTP algorithm"
msgstr "TOTP algorithm"

msgid "TOTP code might be invalid due to incorrect system clock on this device. Please set your system time to the current time."
msgstr "TOTP code might be invalid due to incorrect system clock on this device. Please set your system time to the current time."

msgid "TOTP code:"
msgstr "TOTP code:"

msgid "TOTP length"
msgstr "TOTP length"

msgid "TOTP period"
msgstr "TOTP period"

msgid "TOTP secret"
msgstr "TOTP secret"

msgid "Try again"
msgstr "Try again"

msgid "Unknown credit card"
msgstr "Unknown credit card"

msgid "Unknown error"
msgstr "Unknown error"

#. placeholder {0}: error?.name
msgid "Unknown error: {0}"
msgstr "Unknown error: {0}"

msgid "Unknown field"
msgstr "Unknown field"

msgid "Unknown Passkey"
msgstr "Unknown Passkey"

msgid "Unknown Wi-Fi network"
msgstr "Unknown Wi-Fi network"

msgid "Unnamed login"
msgstr "Unnamed login"

msgid "Unnamed team"
msgstr "Unnamed team"

msgid "Use as default settings"
msgstr "Use as default settings"

msgid "User display name"
msgstr "User display name"

msgid "Username"
msgstr "Username"

msgid "Username or e-mail address"
msgstr "Username or e-mail address"

msgid "Valid from"
msgstr "Valid from"

msgid "Valid until"
msgstr "Valid until"

msgid "Waiting to check"
msgstr "Waiting to check"

msgid "Website"
msgstr "Website"

msgid "Website or app"
msgstr "Website or app"

msgid "Websites"
msgstr "Websites"

msgid "Wi-Fi network"
msgstr "Wi-Fi network"

msgid "Windows app"
msgstr "Windows app"

msgid "Windows apps"
msgstr "Windows apps"

msgctxt "it = credit card"
msgid "You can only read it."
msgstr "You can only read it."

msgctxt "it = ELSTER certificate"
msgid "You can only read it."
msgstr "You can only read it."

msgctxt "it = login"
msgid "You can only read it."
msgstr "You can only read it."

msgctxt "it = note"
msgid "You can only read it."
msgstr "You can only read it."

msgctxt "it = passkey"
msgid "You can only read it."
msgstr "You can only read it."

msgctxt "it = Wi-Fi"
msgid "You can only read it."
msgstr "You can only read it."

msgid "You can only read this credit card."
msgstr "You can only read this credit card."

msgid "You can only read this ELSTER certificate."
msgstr "You can only read this ELSTER certificate."

msgid "You can only read this login."
msgstr "You can only read this login."

msgid "You can only read this note."
msgstr "You can only read this note."

msgid "You can only read this passkey."
msgstr "You can only read this passkey."

msgid "You can only read this Wi-Fi network."
msgstr "You can only read this Wi-Fi network."

msgctxt "it = ELSTER certificate"
msgid "You can only use it to log in with the heylogin browser extension."
msgstr "You can only use it to log in with the heylogin browser extension."

msgctxt "it = login"
msgid "You can only use it to log in with the heylogin browser extension."
msgstr "You can only use it to log in with the heylogin browser extension."

msgid "You can only use this ELSTER certificate to log in with the heylogin browser extension."
msgstr "You can only use this ELSTER certificate to log in with the heylogin browser extension."

msgid "You can only use this login to log in with the heylogin browser extension."
msgstr "You can only use this login to log in with the heylogin browser extension."

msgid "You have {remainingMinutes, plural, one {less than one minute} other {# minutes}} to edit this credit card. After that, only {ownerEmail} can edit it."
msgstr "You have {remainingMinutes, plural, one {less than one minute} other {# minutes}} to edit this credit card. After that, only {ownerEmail} can edit it."

msgid "You have {remainingMinutes, plural, one {less than one minute} other {# minutes}} to edit this login. After that, only {ownerEmail} can edit it."
msgstr "You have {remainingMinutes, plural, one {less than one minute} other {# minutes}} to edit this login. After that, only {ownerEmail} can edit it."

msgid "Your browser was unable to access the security key. You may need to grant permissions in your operating system."
msgstr "Your browser was unable to access the security key. You may need to grant permissions in your operating system."
